import {MC_2_0_PLANS} from './constants'

function getUpgradeIncentivePlans(
  selectedCenters,
  defaultCenters,
  paymentPreview,
) {
  const defaultCenterTypes = defaultCenters.map(({name}) => name.split(' ')[0])
  const excludedCenters = ['mc_pro_enh-5-thryv-m2m']
  let matchedPlanNames = []

  for (const selectedCenter of selectedCenters) {
    const centerType = selectedCenter.name.split(' ')[0]
    const isCenter =
      selectedCenter.name.includes('Center') ||
      selectedCenter.code.startsWith('cc_') ||
      selectedCenter.code === 'keap_max-5-thryv-m2m' ||
      MC_2_0_PLANS.includes(selectedCenter.code)

    if (excludedCenters.includes(selectedCenter.code)) {
      continue
    }

    if (!paymentPreview) {
      if (selectedCenter.code.startsWith('cc_')) {
        const selectedCC = selectedCenter
        const defaultCC = defaultCenters.find(center =>
          center.code.startsWith('cc_'),
        )

        if (selectedCC.name !== defaultCC.name) {
          matchedPlanNames.push(selectedCenter.name.toLowerCase())
        }
      }

      if (!defaultCenterTypes.includes(centerType) && isCenter) {
        matchedPlanNames.push(selectedCenter.name.toLowerCase())
      }
    }

    if (paymentPreview && isCenter) {
      const hasDiscount = paymentPreview.centers.some(
        ({planCode, discount}) => selectedCenter.code === planCode && discount,
      )
      if (hasDiscount) {
        matchedPlanNames.push(selectedCenter.name.toLowerCase())
      }
    }
  }
  return matchedPlanNames
}

export {getUpgradeIncentivePlans}
